import { createI18n } from 'vue-i18n';
import zhCN from './locales/zh-CN.json';
import en from './locales/en.json';

// 1. 定义你的语言包骨架类型
export type MessageSchema = typeof zhCN;
// 2. 定义允许的语言标识符类型
export type LocaleType = 'zh-CN' | 'en';

// 3. 显式传入泛型参数，确保实例内部类型安全
const i18n = createI18n<[MessageSchema], LocaleType>({
  // 1. 关闭旧版的兼容模式
  legacy: false,
  // 2. 设置项目当前的默认语言
  locale: 'zh-CN',
  // 3. 设置项目当前的备用语言
  fallbackLocale: 'en',
  // 4. 设置项目当前的语言包
  messages: {
    'zh-CN': zhCN,
    en
  }
});

export default i18n;
export const globalT = i18n.global.t;
